module.exports = __webpack_public_path__ + "static/media/arrow-left-white.4a5aa736.svg";